/**
 * @generated SignedSource<<2281be5b2c1c61db851fd4260ea0eacf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ExternalPullRequestStatus = "DECLINED" | "DRAFT" | "MERGED" | "OPEN" | "QUEUED" | "UNKNOWN" | "%future added value";
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphPullRequest_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly containerName: string | null;
  readonly entity: {
    readonly container?: {
      readonly name?: string | null;
    } | null;
    readonly lastUpdate?: string | null;
    readonly pullRequestId?: string | null;
    readonly pullRequestStatus?: ExternalPullRequestStatus | null;
    readonly title?: string | null;
  } | null;
  readonly excerpt: string | null;
  readonly id: string;
  readonly initialContributors: ReadonlyArray<{
    readonly name: string | null;
    readonly picture: AGG$URL | null;
  }> | null;
  readonly lastModifiedDate: string | null;
  readonly linkedEntities: ReadonlyArray<{
    readonly id: string;
  }> | null;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null;
    readonly lastModifiedDate: string | null;
    readonly providerId: string | null;
    readonly subtype: string | null;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null;
  readonly permissionLevel: string | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"threadBody_AtlassianSearchPage">;
  readonly " $fragmentType": "searchGraphPullRequest_AtlassianSearchPage";
};
export type searchGraphPullRequest_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphPullRequest_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphPullRequest_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
},
v2 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphPullRequest_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "permissionLevel"
    },
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    {
      "kind": "ScalarField",
      "name": "containerName"
    },
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v3/*: any*/),
            {
              "kind": "ScalarField",
              "name": "lastUpdate"
            },
            {
              "kind": "ScalarField",
              "name": "pullRequestId"
            },
            {
              "alias": "pullRequestStatus",
              "kind": "ScalarField",
              "name": "status"
            },
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v4/*: any*/)
                  ],
                  "type": "ExternalRepository"
                }
              ]
            }
          ],
          "type": "ExternalPullRequest"
        }
      ]
    },
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "initialContributors",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "picture"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "threadBody_AtlassianSearchPage"
    },
    {
      "concreteType": "SearchResultGraphDocument",
      "kind": "LinkedField",
      "name": "linkedEntities",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v3/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "8a0af99579aaad577a3dc3ce55453372";

export default node;
